import { graphql } from '@gql/gql';

export const catalogRatioMassApplyGql = graphql(`
    mutation catalogRatioMassApply($input: CatalogRatioMassApplyInput!) {
        catalogRatioMassApply(input: $input) {
            result
            message
            validation {
                property
                message
            }
        }
    }
`);

export const massApplicationBaseCostsSectionNameFilterGql = graphql(`
    query massApplicationBaseCostsSectionNameFilter(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $ratioGroupIds: [Long!]
        $where: CatalogUERBaseCostDataFilterInput
        $order: [CatalogUERBaseCostDataSortInput!]
    ) {
        catalogUERBaseCostItems(
            skip: $skip
            take: $take
            catalogUniqueId: $catalogUniqueId
            ratioGroupIds: $ratioGroupIds
            where: $where
            order: $order
        ) {
            items {
                id
                sectionName
            }
            totalCount
        }
    }
`);

export const massApplicationBaseCostsGroupNameFilterGql = graphql(`
    query massApplicationBaseCostsGroupNameFilter(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $ratioGroupIds: [Long!]
        $where: CatalogUERBaseCostDataFilterInput
        $order: [CatalogUERBaseCostDataSortInput!]
    ) {
        catalogUERBaseCostItems(
            skip: $skip
            take: $take
            catalogUniqueId: $catalogUniqueId
            ratioGroupIds: $ratioGroupIds
            where: $where
            order: $order
        ) {
            items {
                id
                groupName
            }
            totalCount
        }
    }
`);

export const massApplicationBaseCostsCodeFilterGql = graphql(`
    query massApplicationBaseCostsCodeFilter(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $ratioGroupIds: [Long!]
        $where: CatalogUERBaseCostDataFilterInput
        $order: [CatalogUERBaseCostDataSortInput!]
    ) {
        catalogUERBaseCostItems(
            skip: $skip
            take: $take
            catalogUniqueId: $catalogUniqueId
            ratioGroupIds: $ratioGroupIds
            where: $where
            order: $order
        ) {
            items {
                id
                code
            }
            totalCount
        }
    }
`);

export const massApplicationBaseCostsNameFilterGql = graphql(`
    query massApplicationBaseCostsNameFilter(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $ratioGroupIds: [Long!]
        $where: CatalogUERBaseCostDataFilterInput
        $order: [CatalogUERBaseCostDataSortInput!]
    ) {
        catalogUERBaseCostItems(
            skip: $skip
            take: $take
            catalogUniqueId: $catalogUniqueId
            ratioGroupIds: $ratioGroupIds
            where: $where
            order: $order
        ) {
            items {
                id
                name
            }
            totalCount
        }
    }
`);
